module.exports = __webpack_public_path__ + "static/img/12.9642169.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rootDoc/img/12.png
// module id = Vr6n
// module chunks = 1